import { Tabs } from 'antd'
import { useState } from 'react'
import { ContractBookingListComponent2 } from '../contract-booking-list-2.component'
import TimeTable from './time-table'

const items = [
  {
    key: '1',
    label: 'Calendar',
    children: <TimeTable />
  },
  {
    key: '2',
    label: 'Table',
    children: <ContractBookingListComponent2 />
  }
]

const Schedule2 = () => {
  const [activeTab, setActiveTab] = useState('1')

  return (
    <div className='site-page'>
      <div className='site-page-header'>
        <span>Schedule Planner</span>
      </div>
      <div className='side-page-tabs'>
        <Tabs defaultActiveKey={activeTab} items={items} onChange={(value) => setActiveTab(value)} />
      </div>
    </div>
  )
}

export default Schedule2
